module.exports = __webpack_public_path__ + "d3907b26cf829e91854cb1eae284efb2.svg";